export function systemRoleName(t, role) {
  const code = role?.systemCode
  if (code === 'ADMIN') return t('administrator')
  if (code === 'MANAGER') return t('manager')
  if (code === 'SERVICE_SPECIALIST') return t('serviceSpecialist')
  if (code === 'OPERATOR') return t('operator')
  return role?.displayName ?? ''
}

export function permissionName(t, permission) {
  const key = `permission_${permission.key.replaceAll('.', '_')}`
  const translated = t(key)
  return translated === key ? permission.displayName : translated
}

export function permissionGroupName(t, group) {
  const key = `permissionGroup_${group.key}`
  const translated = t(key)
  return translated === key ? group.displayName : translated
}

export function permissionAreaName(t, areaKey) {
  const key = `permissionArea_${areaKey}`
  const translated = t(key)
  return translated === key ? areaKey : translated
}
